export const parseIntSafely = (value: any) => {
  if (value === null || value === undefined) return null;
  if (Number.isFinite(value)) return value;
  if (typeof value === 'string') {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : null
  }
  return null
}
